// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"22":"ba5f9e0f","169":"96b976cf"}[chunkId] + ".js";
};